import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import Icon from "../../../components/Icon"

function TasksInfoModal({ showSignal, handleCancel, referenceGuid}) {

	return (
		<Modal show={showSignal.value} onHide={handleCancel} size="xl">
			<Modal.Header closeButton>
				<Modal.Title>About Tasks</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>The Tasks tab displays the tasks for the selected account for the previous 30 days by default. Filters can be used to refine which tasks to display.</p>
				<p>The information displayed is for monitoring the state of tasks. For example, if a task was scheduled to deploy a UTG version but its state is failed, then a new task can be scheduled to reattempt the deployment. The possible states are:</p>
				<dl>
					<dt>Scheduled</dt><dd>The task has been requested at the scheduled date and time.</dd>
					<dt>Running</dt><dd>The task has been scheduled and will be completed as soon as possible. It will remain in this state until completed or failed. If the task remains running for a long period of time, check your connection between Shift4 Command Center, the Shift4 Command Center Agent, and the UTG.</dd>
					<dt>Completed</dt><dd>The task was completed successfully.</dd>
					<dt>Failed</dt><dd>The task could not be completed.</dd>
				</dl>
				<p>In addition, you can do the following to create a report:</p>
				<ol>
					<li className="my-1 disc">From the item gear icon, select 'Copy Row as JSON' to copy all the information displayed in the task&#39;s row, allowing you to paste the information where you&#39;d like.</li>
					<li className="my-1 disc">Click the 'Download data as CSV' button to download a CSV file that contains all the tasks for the selected account for the previous 30 days.</li>
				</ol>
				<br />
				<p>For more information, click <b>Reference Guide.</b></p>
			</Modal.Body>
			<Modal.Footer>
				<Button type="button" style={{ fill: "white" }} onClick={() => { window.open(referenceGuid) }}>
					<Icon icon="book" height={16} width={16}></Icon>&nbsp;&nbsp;Reference Guide
				</Button>
				<Button variant='outline-secondary' type="button" onClick={handleCancel}>Close</Button>
			</Modal.Footer>
		</Modal>
    )
}

export default TasksInfoModal